import misc from './misc';

const { getEmailQuery, buildTestEmail } = misc;

export default {
  userInviteOne: {
    title: 'User Invite » Invite To Join The Platform',
    description: 'Sent via the Invite Employees page',
    hide: ({ isReferralsFeatureEnabled }) => !isReferralsFeatureEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.inviteEmailFirstPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_INVITE_FIRST_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_INVITE_FIRST_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_INVITE_FIRST_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('users/invite-1', {
      template_bodyOne: 'template.EMAIL_INVITE_FIRST_BODY_ONE',
      template_plainHTML: 'template.EMAIL_INVITE_FIRST_PLAIN_HTML',
    }, {
      company: {
        userInvite: {
          id: '1',
          name: 'Riley McFarland',
          emailAddress: 'riley@example.com',
          user: {
            id: '1',
            fullName: 'Nazia Houston',
            emailAddress: 'nazia@example.com',
          },
        },
      },
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        inviteEmailFirstPlain
      }

      template_subject: template(where: {
        key: "EMAIL_INVITE_FIRST_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_INVITE_FIRST_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_INVITE_FIRST_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
  },
  userInviteTwo: {
    title: 'User Invite » Reminder',
    description: '7 days after invite if not signed up ',
    hide: ({ isReferralsFeatureEnabled }) => !isReferralsFeatureEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.inviteEmailSecondPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_INVITE_SECOND_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_INVITE_SECOND_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_INVITE_SECOND_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('users/invite-2', {
      template_bodyOne: 'template.EMAIL_INVITE_SECOND_BODY_ONE',
    }, {
      company: {
        userInvite: {
          id: '1',
          name: 'Riley McFarland',
          emailAddress: 'riley@example.com',
          user: {
            id: '1',
            fullName: 'Nazia Houston',
            emailAddress: 'nazia@example.com',
          },
        },
      },
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        inviteEmailSecondPlain
      }

      template_subject: template(where: {
        key: "EMAIL_INVITE_SECOND_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_INVITE_SECOND_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_INVITE_SECOND_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
  },
  userInviteThree: {
    title: 'User Invite » Final Reminder',
    description: '14 days after invite if not signed up',
    hide: ({ isReferralsFeatureEnabled }) => !isReferralsFeatureEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.inviteEmailThirdPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_INVITE_THIRD_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_INVITE_THIRD_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_INVITE_THIRD_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('users/invite-3', {
      template_bodyOne: 'template.EMAIL_INVITE_THIRD_BODY_ONE',
    }, {
      company: {
        userInvite: {
          id: '1',
          name: 'Riley McFarland',
          emailAddress: 'riley@example.com',
          user: {
            id: '1',
            fullName: 'Nazia Houston',
            emailAddress: 'nazia@example.com',
          },
        },
      },
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        inviteEmailThirdPlain
      }

      template_subject: template(where: {
        key: "EMAIL_INVITE_THIRD_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_INVITE_THIRD_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_INVITE_THIRD_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
  },
  imUserInviteOne: {
    title: 'Internal Mobility User Invite » Invite To Join The Platform',
    description: 'Sent via the Invite Employees page',
    hide: ({ isReferralsFeatureEnabled, isInternalMobilityEnabled }) => isReferralsFeatureEnabled || !isInternalMobilityEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.imInviteEmailFirstPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_IM_INVITE_FIRST_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_IM_INVITE_FIRST_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_IM_INVITE_FIRST_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('users/im-invite-1', {
      template_bodyOne: 'template.EMAIL_IM_INVITE_FIRST_BODY_ONE',
      template_plainHTML: 'template.EMAIL_IM_INVITE_FIRST_PLAIN_HTML',
    }, {
      company: {
        userInvite: {
          id: '1',
          name: 'Riley McFarland',
          emailAddress: 'riley@example.com',
          user: {
            id: '1',
            fullName: 'Nazia Houston',
            emailAddress: 'nazia@example.com',
          },
        },
      },
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        imInviteEmailFirstPlain
      }

      template_subject: template(where: {
        key: "EMAIL_IM_INVITE_FIRST_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_IM_INVITE_FIRST_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_IM_INVITE_FIRST_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
  },
  imUserInviteTwo: {
    title: 'Internal Mobility User Invite » Reminder',
    description: '7 days after invite if not signed up ',
    hide: ({ isReferralsFeatureEnabled, isInternalMobilityEnabled }) => isReferralsFeatureEnabled || !isInternalMobilityEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.imInviteEmailSecondPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_IM_INVITE_SECOND_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_IM_INVITE_SECOND_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_IM_INVITE_SECOND_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('users/im-invite-2', {
      template_bodyOne: 'template.EMAIL_IM_INVITE_SECOND_BODY_ONE',
    }, {
      company: {
        userInvite: {
          id: '1',
          name: 'Riley McFarland',
          emailAddress: 'riley@example.com',
          user: {
            id: '1',
            fullName: 'Nazia Houston',
            emailAddress: 'nazia@example.com',
          },
        },
      },
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        imInviteEmailSecondPlain
      }

      template_subject: template(where: {
        key: "EMAIL_IM_INVITE_SECOND_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_IM_INVITE_SECOND_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_IM_INVITE_SECOND_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
  },
  imUserInviteThree: {
    title: 'Internal Mobility User Invite » Final Reminder',
    description: '14 days after invite if not signed up',
    hide: ({ isReferralsFeatureEnabled, isInternalMobilityEnabled }) => isReferralsFeatureEnabled || !isInternalMobilityEnabled,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.imInviteEmailThirdPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_IM_INVITE_THIRD_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_IM_INVITE_THIRD_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_IM_INVITE_THIRD_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('users/invite-3', {
      template_bodyOne: 'template.EMAIL_IM_INVITE_THIRD_BODY_ONE',
    }, {
      company: {
        userInvite: {
          id: '1',
          name: 'Riley McFarland',
          emailAddress: 'riley@example.com',
          user: {
            id: '1',
            fullName: 'Nazia Houston',
            emailAddress: 'nazia@example.com',
          },
        },
      },
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        imInviteEmailThirdPlain
      }

      template_subject: template(where: {
        key: "EMAIL_IM_INVITE_THIRD_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_IM_INVITE_THIRD_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_IM_INVITE_THIRD_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
  },
  mentorInviteOne: {
    title: 'Mentor Invite » Invite To Join The Platform',
    hide: ({ isInternalMobilityEnabled }) => !isInternalMobilityEnabled,
    description: 'Sent via the Invite Employees page',
    isInternalMobility: true,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.inviteMentorEmailFirstPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_INVITE_MENTOR_ONE_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_INVITE_MENTOR_ONE_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_INVITE_MENTOR_ONE_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('users/invite-mentor-1', {
      template_bodyOne: 'template.EMAIL_INVITE_MENTOR_ONE_BODY_ONE',
    }, {
      company: {
        userInvite: {
          id: '1',
          name: 'Riley McFarland',
          emailAddress: 'riley@example.com',
          user: {
            id: '1',
            fullName: 'Nazia Houston',
            emailAddress: 'nazia@example.com',
          },
        },
      },
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        inviteMentorEmailFirstPlain
      }

      template_subject: template(where: {
        key: "EMAIL_INVITE_MENTOR_ONE_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_INVITE_MENTOR_ONE_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_INVITE_MENTOR_ONE_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
    mockData(result) {
      const fakeData = {
        company: {
          userInvite: {
            id: 'testid',
            name: 'Miley McMiland',
          }
        }
      };
      return {
        ...result,
        company: {
          ...result.company,
          ...fakeData.company,
        },
      };
    },
  },
  mentorInviteTwo: {
    title: 'Mentor Invite » Reminder',
    description: '7 days after invite if not signed up ',
    hide: ({ isInternalMobilityEnabled }) => !isInternalMobilityEnabled,
    isInternalMobility: true,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.inviteMentorEmailSecondPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_INVITE_MENTOR_TWO_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_INVITE_MENTOR_TWO_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_INVITE_MENTOR_TWO_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('users/invite-mentor-2', {
      template_bodyOne: 'template.EMAIL_INVITE_MENTOR_TWO_BODY_ONE',
    }, {
      company: {
        userInvite: {
          id: '1',
          name: 'Riley McFarland',
          emailAddress: 'riley@example.com',
          user: {
            id: '1',
            fullName: 'Nazia Houston',
            emailAddress: 'nazia@example.com',
          },
        },
      },
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        inviteMentorEmailSecondPlain
      }

      template_subject: template(where: {
        key: "EMAIL_INVITE_MENTOR_TWO_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_INVITE_MENTOR_TWO_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_INVITE_MENTOR_TWO_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
    mockData(result) {
      const fakeData = {
        company: {
          userInvite: {
            id: 'testid',
            name: 'Miley McMiland',
          }
        }
      };
      return {
        ...result,
        company: {
          ...result.company,
          ...fakeData.company,
        },
      };
    },
  },
  mentorInviteThree: {
    title: 'Mentor Invite » Final Reminder',
    description: '14 days after invite if not signed up ',
    hide: ({ isInternalMobilityEnabled }) => !isInternalMobilityEnabled,
    isInternalMobility: true,
    tabs: [
      {
        title: 'Rich Content Email',
        key: 'rich-content-email',
      },
      {
        title: 'Plain Text Email',
        key: 'plain-text-email',
      }
    ],
    fields: [
      {
        key: 'preferences.inviteMentorEmailThirdPlain',
        label: 'Use plain text email',
        description: 'Send plain text email as defined under the plain text email tab',
        type: 'boolean',
      },
      {
        key: 'template.EMAIL_INVITE_MENTOR_THREE_SUBJECT',
        label: 'Email subject',
        type: 'template',
      },
      {
        key: 'template.EMAIL_INVITE_MENTOR_THREE_PLAIN_HTML',
        label: 'Plain Text Email',
        type: 'template',
        markdown: true,
        tab: 'plain-text-email',
      },
      {
        key: 'template.EMAIL_INVITE_MENTOR_THREE_BODY_ONE',
        label: 'Email top message',
        type: 'template',
        markdown: true,
        tab: 'rich-content-email',
      },
    ],
    sendTestEmail: buildTestEmail('users/invite-mentor-3', {
      template_bodyOne: 'template.EMAIL_INVITE_MENTOR_THREE_BODY_ONE',
    }, {
      company: {
        userInvite: {
          id: '1',
          name: 'Riley McFarland',
          emailAddress: 'riley@example.com',
          user: {
            id: '1',
            fullName: 'Nazia Houston',
            emailAddress: 'nazia@example.com',
          },
        },
      },
    }),
    testDataQuery: getEmailQuery({
      company: `preferences {
        useGamification
        inviteMentorEmailThirdPlain
      }

      template_subject: template(where: {
        key: "EMAIL_INVITE_MENTOR_THREE_SUBJECT",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_bodyOne: template(where: {
        key: "EMAIL_INVITE_MENTOR_THREE_BODY_ONE",
        lang: "en",
        default: false,
      }) {
        value
      }
      template_plainHTML: template(where: {
        key: "EMAIL_INVITE_MENTOR_THREE_PLAIN_HTML",
        lang: "en",
        default: false,
      }) {
        value
      }`,
    }),
    mockData(result) {
      const fakeData = {
        company: {
          userInvite: {
            id: 'testid',
            name: 'Miley McMiland',
          }
        }
      };
      return {
        ...result,
        company: {
          ...result.company,
          ...fakeData.company,
        },
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/emails/previews/userInviteEmails.js